var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('feed-list',{directives:[{name:"show",rawName:"v-show",value:(_vm.state === _vm.states.list),expression:"state === states.list"}],on:{"manageFeedMasks":_vm.manageFeedMasks}}),(_vm.state === _vm.states.masks)?_c('feed-masks',{attrs:{"feed":_vm.feed},on:{"closePage":_vm.closePage}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }